export default "__VITE_ASSET___iWjoT_T__"